// extracted by mini-css-extract-plugin
export default {"innerWrapper":"NB-z","tooltipWrapper":"OB-z","icon":"PB-z","tooltip":"QB-z","content":"RB-z"};